// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b5f7d14a","453":"6933ba0b"}[chunkId] + ".chunk.js";
};